import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider, RequireAuth } from "./context/AuthContext";
import AppShell from "./components/layout/AppShell";
import Login from "./routes/Login";
import { appVariant, isSection } from "./config/appVariant";

// Side-effect import: sets x-api-key default on global axios
import "./utils/api";

/* Account Balance Routes */
import AccountBalance from "./parallax/routes/accounts/AccountBalance";
import AddAccountBalance from "./parallax/routes/accounts/AddAccountBalance";
import AddAccountBalances from "./parallax/routes/accounts/AddAccountBalances";
import UpdateAccountBalance from "./parallax/routes/accounts/UpdateAccountBalance";

/* PARALLAX */
import LavellaDashboard from "./parallax/routes/dashboard/LavellaDashboard";
import SpendingAverages from "./parallax/routes/spending/SpendingAverages";
import Ledger from "./parallax/routes/spending/Ledger";
import Reoccurring from "./parallax/routes/spending/Reoccurring";
import Accounts from "./parallax/routes/accounts/Accounts";

/* Money Dashboard */
import MoneyHome from "./parallax/routes/MoneyHome";

/* Budget */
import BudgetForecast from "./parallax/routes/budget/BudgetForecast";
import BudgetItemList from "./parallax/routes/budget/BudgetItemList";
import BudgetItemEdit from "./parallax/routes/budget/BudgetItemEdit";

/* Net Worth */
import NetWorthList from "./parallax/routes/networth/NetWorthList";
import NetWorthEdit from "./parallax/routes/networth/NetWorthEdit";

function AppContent() {
	useEffect(() => {
		document.title = appVariant.name;
	}, []);

	return (
		<AppShell>
			<Routes>
				{/* Main Dashboard / Variant-aware home */}
				<Route path="/" element={<MoneyHome />} />

				{/* Money Routes */}
				{isSection("money") && (
					<>
						<Route path="/budget-forecast" element={<BudgetForecast />} />
						<Route path="/budget-items" element={<BudgetItemList />} />
						<Route path="/budget-items/:id" element={<BudgetItemEdit />} />
						<Route path="/networth" element={<NetWorthList />} />
						<Route path="/networth/:id" element={<NetWorthEdit />} />
						<Route path="/lavella-dashboard" element={<LavellaDashboard />} />
						<Route path="/spending-averages" element={<SpendingAverages />} />
						<Route path="/ledger" element={<Ledger />} />
						<Route path="/reoccurring" element={<Reoccurring />} />
						<Route path="/accounts" element={<Accounts />} />
						<Route path="/accountBalance" element={<AccountBalance />} />
						<Route path="/addAccountBalance" element={<AddAccountBalance />} />
						<Route path="/addAccountBalances/:group" element={<AddAccountBalances />} />
						<Route path="/updateAccountBalance/:id" element={<UpdateAccountBalance />} />
					</>
				)}

				{isSection("money") && <Route path="/money" element={<MoneyHome />} />}

				{/* Catch-all: redirect to variant default */}
				<Route path="*" element={<Navigate to={appVariant.defaultRoute} replace />} />
			</Routes>
		</AppShell>
	);
}

function App() {
	return (
		<ThemeProvider>
			<AuthProvider>
				<div className="app">
					<BrowserRouter>
						<Routes>
							{/* Login - no auth required */}
							<Route path="/login" element={<Login />} />

							{/* Everything else requires auth */}
							<Route
								path="/*"
								element={
									<RequireAuth>
										<Routes>
											{/* All other routes with AppShell */}
											<Route path="/*" element={<AppContent />} />
										</Routes>
									</RequireAuth>
								}
							/>
						</Routes>
					</BrowserRouter>
				</div>
			</AuthProvider>
		</ThemeProvider>
	);
}

export default App;
